/** The shape of the error PostgREST hands back from `.rpc()` and queries. */
export interface PostgrestErrorLike {
  code?: string | null;
  message?: string;
}

/**
 * The readable message of anything a Supabase call can reject with. `.rpc()`
 * and queries return their error as a plain object, not an `Error` (only
 * `throwOnError()` builds a real one), so `String(error)` on a rethrown one
 * renders "[object Object]" — which is what the organise dialog showed for a
 * perfectly clear server refusal.
 */
export function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof error.message === "string"
  ) {
    return error.message;
  }
  return String(error);
}

/** PGRST202 = no matching RPC in the schema cache; 42883 = undefined function. */
const MISSING_FUNCTION_CODES: ReadonlySet<string> = new Set(["PGRST202", "42883"]);

/**
 * True when the error means the RPC does not exist on this database yet — the
 * app shipped ahead of the migration that creates it. Callers use this to
 * degrade explicitly instead of reporting a generic failure.
 */
export function isMissingFunctionError(error: PostgrestErrorLike | null | undefined): boolean {
  return Boolean(error?.code && MISSING_FUNCTION_CODES.has(error.code));
}
